import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SectionLabel } from "../../components/ui";
import { useAuth } from "../../auth/auth-context";

const inputClass =
  "w-full box-border px-[16px] py-[15px] rounded-[13px] bg-white border border-line " +
  "text-[15px] text-ink placeholder:text-ink4/70 outline-none focus:border-ink";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setInfo("");

    const trimmed = email.trim();
    if (!trimmed) {
      setError("請輸入電郵地址");
      return;
    }
    // 基本電郵格式驗證
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("請輸入有效的電郵地址");
      return;
    }

    setBusy(true);
    try {
      const result = await requestPasswordReset(trimmed);
      if (result.error) {
        setError(result.error);
      } else {
        setInfo("重置密碼郵件已發送，請查收（包含垃圾郵件）");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-dvh box-border bg-cream flex flex-col px-[max(26px,5vw)] pt-[60px] pb-[34px]">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="self-start font-grotesk text-[13.5px] text-ink4 cursor-pointer bg-transparent border-none p-0"
      >
        ← 返回
      </button>

      <div className="mt-[44px]">
        <SectionLabel>MANGO WORD · 帳戶</SectionLabel>
        <h1 className="mt-[14px] mb-0 text-[32px] leading-[1.25] font-bold text-ink tracking-[-.01em]">
          重置密碼
        </h1>
        <p className="mt-[12px] mb-0 text-[15px] leading-[1.7] text-ink4">
          請輸入註冊時用的電郵地址，我們會發送重置密碼的連結。
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mt-[28px] flex flex-col gap-[13px]" noValidate>
        <label className="flex flex-col gap-2 text-[12px] font-medium text-ink3">
          電郵地址
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            aria-label="電郵地址"
            className={inputClass}
            placeholder="name@example.com"
          />
        </label>

        {error && <div role="alert" className="text-[13.5px] text-accent-deep">{error}</div>}
        {info && <div role="status" className="text-[13.5px] text-ink">{info}</div>}

        <button
          type="submit"
          disabled={busy}
          aria-busy={busy}
          className="mt-[6px] w-full rounded-full py-4 text-[16px] font-bold cursor-pointer bg-ink text-cream disabled:opacity-50"
        >
          {busy ? "發送中…" : "發送重置連結"}
        </button>
      </form>
    </div>
  );
}
